module.exports = __webpack_public_path__ + "static/media/Profile_IPOIntelligence_base.6808a4e1.png";